import { Component, OnInit, ViewChild } from "@angular/core";
import { NatureGarantieService } from "src/app/parametrage/core/service/nature-garantie.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NatureGarantieDocument } from "src/app/parametrage/core/model/garanties/NatureGarantieDocument";
import { TypeDocumentChampGarantieService } from "src/app/parametrage/core/service/type-document-champ-garantie.service";
import { NatureGarantie } from "src/app/parametrage/core/model/garanties/nature-garantie";
import { NatureGarantieChamp } from "src/app/parametrage/core/model/garanties/NatureGarantieChamp";
import { ChampSourceGarantie } from "src/app/parametrage/core/model/garanties/ChampSourceGarantie";
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
} from "@angular/cdk/drag-drop";

@Component({
  selector: "app-set-type-champ-garantie",
  templateUrl: "./set-type-champ-garantie.component.html",
  styleUrls: ["./set-type-champ-garantie.component.scss"],
})
export class SetTypeChampGarantieComponent implements OnInit {
  natureGarantieId: number;
  natureGarantie: NatureGarantie;
  natureGarantieChamps: NatureGarantieChamp[] = [];
  champSources: ChampSourceGarantie[] = [];

  constructor(
    public modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private _natureGarantieService: NatureGarantieService,
    private _typeChampGarantieService: TypeDocumentChampGarantieService
  ) {}

  ngOnInit() {
    this.getEmptyChampSourceGaranties(this.natureGarantieId);
    this.getNatureGarantieChamps();
  }

  getNatureGarantieChamps() {
    this._natureGarantieService
      .getNatureGarantieChamps(this.natureGarantieId)
      .subscribe((data) => {
        //order by position property
        if (data != null) {
          data.sort((a, b) => a.position - b.position);
        }
        this.natureGarantieChamps = data;
      });
  }

  getEmptyChampSourceGaranties(natureGarantieId: number) {
    this._typeChampGarantieService
      .getEmptyChampSourceGaranties(natureGarantieId)
      .subscribe((data) => {
        this.champSources = data;
      });
  }

  onSubmit() {
    if (this.natureGarantieChamps != null) {
      this.natureGarantieChamps.forEach((_) => {
        _.position = this.natureGarantieChamps.indexOf(_);
      });
    }
    this._natureGarantieService
      .associerChamps(this.natureGarantieId, this.natureGarantieChamps)
      .subscribe((data) => {
        this.activeModal.close();
      });
  }

  changeAfterChecked(value: any, champ: NatureGarantieChamp) {
    champ.obligatoire = value.checked;
    console.log(this.natureGarantieChamps);
  }

  drop(event: CdkDragDrop<NatureGarantieChamp[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }
    console.log(this.natureGarantieChamps);
  }
}
